import React, { useState } from "react";
import LayoutDashboard from "../layout/LayoutDashboard";
import { ReactComponent as IconSearch } from "../assets/icons/icon-search.svg";
import DynamicScrollToTop from "../components/misc/DynamicScrollToTop";
import PurchaseReport from "../components/Report/PurchaseReport";

const Purchases = () => {
  const [showReportPopup, setReportPopup] = useState(false);
  function handleShowPopup() {
    setReportPopup(!showReportPopup);
  }
  return (
    <>
      <DynamicScrollToTop />
      <LayoutDashboard>
        <section className="ml-4 w-3/4">
          <div className="md-flex">
            <div className="bg-white">
              <div className="mb-12">
                <div className="flex flex-col rounded-md w-full py-6 px-8 bg-white shadow-lg justify-start h-full">
                  <label className="flex items-center mt-4">
                    <span className="text-font-gray w-2/6 flex justify-end mr-2 ">
                      Area :{" "}
                    </span>
                    <select className="form-select mt-1 block w-6/12">
                      <option>Pilih Kota</option>
                      <option>Malang</option>
                      <option>Surabaya</option>
                    </select>
                    <span className="text-font-gray w-6/12 flex justify-end mr-2 ">
                      Area :{" "}
                    </span>
                    <select className="form-select mt-1 block w-6/12">
                    <option>Pilih Area</option>
                      <option>Area 1</option>
                      <option>Area 2</option>
                      <option>Area 3</option>
                      <option>Area 4</option>
                      <option>Area 5</option>
                    </select>
                  </label>
                  <div className="flex items-start mt-4">
                    <p className="text-font-gray w-2/12 flex justify-end mr-2">
                      Periode :{" "}
                    </p>
                    <div className="flex flex-col mr-4">
                      <label className="block">
                        <span className="text-gray-700">Bulan</span>
                        <select className="form-select mt-1 block w-full">
                          <option>Januari</option>
                          <option>Februari</option>
                          <option>Maret</option>
                          <option>April</option>
                          <option>Mei</option>
                          <option>Juni</option>
                          <option>Juli</option>
                          <option>Agustus</option>
                          <option>September</option>
                          <option>Oktober</option>
                          <option>Desember</option>
                        </select>
                      </label>
                    </div>
                    <div className="flex flex-col mr-4">
                      <label className="block">
                        <span className="text-gray-700">Tahun</span>
                        <select className="form-select mt-1 block w-full">
                          <option>2020</option>
                          <option>2021</option>
                          <option>2022</option>
                          <option>2023</option>
                          <option>2024</option>
                        </select>
                      </label>
                    </div>
                  </div>
                  <div className="flex items-start mt-4">
                    <span className="text-font-gray w-2/12 flex justify-end mr-2 ">
                      Kelompokkan :{" "}
                    </span>
                    <div className="flex flex-col ">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          className="form-radio form-radio-green"
                          name="accountType"
                          value="personal"
                        />
                        <span className="ml-2">Tanggal Pesanan</span>
                      </label>
                      <label className="inline-flex items-center ">
                        <input
                          type="radio"
                          className="form-radio form-radio-green"
                          name="accountType"
                          value="busines"
                        />
                        <span className="ml-2">No. Pesanan</span>
                      </label>
                    </div>{" "}
                  </div>
                  <label className="flex items-center mt-4">
                    <span className="text-font-gray w-2/12 flex justify-end mr-2 ">
                      Format :{" "}
                    </span>
                    <select className="form-select mt-1 block w-6/12">
                      <option>HTML (PRATINJAU) </option>
                      <option>PDF</option>
                      <option>EXCEL</option>
                    </select>
                  </label>
                  <div className="mt-4 mb-8 ml-40">
                    <button
                      onClick={() => handleShowPopup(!showReportPopup)}
                      className="bg-green-500 text-white font-bold py-3 px-4 rounded mt-2 flex"
                    >
                      <IconSearch className="h4 w-4 mr-4 " />
                      Lihat laporan
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {showReportPopup ? (
          <PurchaseReport handdleClick={handleShowPopup} />
        ) : null}
      </LayoutDashboard>
    </>
  );
};
export default Purchases;
